export default {
    abilities: 'Habilidades',
    abilityOne: {
        title: 'Localizar u obtener información.',
        desc: 'Estás en un nivel <strong> {0} </strong> de lectura, te invitamos a continuar ejercitando para mantener tu capacidad de compresión.'
    },
    abilityTwo: {
        title: 'Integrar e interpretar.',
        desc: 'Estás en un nivel <strong> {0} </strong> de lectura, te invitamos a reforzar tu competencia lectora.'
    },
    abilityThree: {
        title: 'Reflexionar y valorar.',
        desc: 'Estás en un nivel <strong> {0} </strong> de lectura, te invitamos a desarrollar y mejorar tu competencia lectora.'
    },
    abilityLevels: ['inicial', 'intermedio', 'avanzado'],
    achievements: 'Logros',
    answered_questions: 'Preguntas Contestadas',
    back_to_avatars: 'Volver a avatares',
    back_to_skins: 'Volver a skins',
    buy_this_avatar: 'Comprar este avatar',
    buy_this_skin: 'Comprar este skin',
    correct_answers: 'Respuestas Correctas',
    edit_avatar: 'Editar avatar',
    edit_my_avatar: 'Editar mi avatar',
    edit_skin: 'Editar Skin',
    global_progress: 'Progreso global',
    global_progress_rank: [
        '4 Semanas',
        '8 Semanas',
        '12 Semanas'
    ],
    leave: 'Salir',
    level: 'Nivel',
    my_categories: 'Mis categorías',
    my_skins: 'Mis skins',
    points: 'Puntos',
    purchase_avatar_desc: 'Este es un avatar especial que puedes adquirir comprándolo con tus Beecoins. Una vez que lo compres, estará disponible en "Avatares especiales".',
    purchase_skin_desc: 'Este es un skin especial que puedes adquirir comprándolo con tus Beecoins. Una vez que lo compres, estará disponible en "Skins especiales".',
    save_changes: 'Guardar cambios',
    special_avatar: 'Avatar especial',
    special_avatars: 'Avatares especiales',
    standard_avatars: 'Avatares estándar',
    special_skin: 'Skin especial',
    special_skins: 'Skins especiales',
    standard_skins: 'Skins estándar',
    you_have: 'Tienes',
    your_collection: 'Tu colección',
    your_favorite_books: 'Tus libros favoritos',
    your_favorite_books_desc: 'Revisa los libros que seleccionaste como imperdibles en tu colección.',
    your_profile: 'Tu perfil',
    menu_edit_tooltip: 'Con este botón podrás modificar tu Avatar, tu Skin y tus Categorias Favoritas.',
    student_code: 'Código de estudiante',
    student_code_message: 'Código copiado en el portapapeles'
}
